import { CheckCircleOutlined, ExclamationCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { FC } from 'react';

import { BannerStatusEnum, BannerStatusTagProps, StatusTagConfig } from '../types/bannerManagement';

const statusConfig: Record<
  BannerStatusEnum,
  StatusTagConfig
> = {
  [BannerStatusEnum.Active]: {
    icon: <CheckCircleOutlined />,
    label: 'Ativo',
    style: {
      padding: '0 8px',
      color: '#389E0D',
      border: '1px solid #274916',
      background: '#162312',
    },
  },
  [BannerStatusEnum.Scheduled]: {
    icon: <ExclamationCircleOutlined />,
    label: 'Agendado',
    style: {
      padding: '0 8px',
      color: '#D89614',
      border: '1px solid #594214',
      background: '#2B2111',
    },
  },
  [BannerStatusEnum.Inactive]: {
    icon: <MinusCircleOutlined />,
    label: 'Inativo',
    style: {
      padding: '0 8px',
      border: '1px solid #424242',
      background: '#FFFFFF0A',
    },
  },
  [BannerStatusEnum.Draft]: {
    icon: <MinusCircleOutlined />,
    label: 'Rascunho',
    style: {
      padding: '0 8px',
      border: '1px dashed #424242',
      background: '#FFFFFF0A',
    },
  },
};

export const BannerStatusTag: FC<BannerStatusTagProps> = ({ status }) => {
  const config = statusConfig[status];

  return (
    <Tag icon={config.icon} style={config.style}>
      {config.label}
    </Tag>
  );
};
